var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.869 17.236l-5.375-5.376c.065-.074.13-.148.191-.224.156-.192.127-.474-.065-.63-.191-.155-.473-.126-.629.066-.133.164-.277.324-.428.475-1.178 1.182-2.745 1.835-4.413 1.838h-.011c-1.664 0-3.229-.648-4.407-1.824C1.55 10.384.898 8.817.895 7.148c-.003-1.669.643-3.239 1.82-4.42C5.149.288 9.11.283 11.549 2.714c1.815 1.81 2.34 4.6 1.307 6.946-.1.226.002.49.228.59.226.099.49-.003.59-.23 1.181-2.68.58-5.871-1.494-7.94C9.391-.7 4.862-.691 2.082 2.097.736 3.446-.003 5.24 0 7.149c.004 1.908.75 3.7 2.1 5.046 1.347 1.344 3.136 2.084 5.039 2.084h.012c1.753-.003 3.408-.635 4.71-1.787l5.376 5.377c.087.087.201.131.316.131.114 0 .229-.044.316-.131.175-.175.175-.458 0-.633z",
    transform: "translate(6 6) translate(3 3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(6 6)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search-active.311e68c741f954f69b92d766da217907.svg";
export { ForwardRef as ReactComponent };